import { ResolvedFn, RejectedFn } from '../types';
import { userInfo } from 'os';

interface Interceptor<T> {
  resolved: ResolvedFn<T>;
  rejected?: RejectedFn;
}

export default class InterceptorManager<T> {
  private interceptors: Array<Interceptor<T> | null>; // 存储添加的拦截器

  constructor() {
    this.interceptors = [];
  }

  // 添加拦截器
  use(resolved: ResolvedFn<T>, rejected?: RejectedFn): number {
    this.interceptors.push({
      resolved,
      rejected
    });
    return this.interceptors.length -1;
  }

  // 拦截器内部使用
  forEach(fn: (Interceptor: Interceptor<T>) => void):void {
    this.interceptors.forEach(interceptor => {
      if(interceptor !== null) {
        fn(interceptor);
      }
    })
  }

  // 删除拦截器
  eject(id:number): void {
    if(this.interceptors[id]) {
      this.interceptors[id] = null;
    }
  }
}